// ============================================================
// WelcomeBanner Component
// ============================================================
// Displays a personalized greeting and high-level context.

import { Box, Typography } from '@mui/material';
import { tokens } from '@/theme/tokens';

export function WelcomeBanner({ user, currentSchool, action }) {
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good Morning';
    if (hour < 18) return 'Good Afternoon';
    return 'Good Evening';
  };

  return (
    <Box
      sx={{
        backgroundColor: tokens.colors.primary.main,
        color: tokens.colors.primary.contrastText,
        borderRadius: tokens.radius.lg,
        p: { xs: 3, md: 4 },
        mb: 4,
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'center' },
        justifyContent: 'space-between',
        gap: 2,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        <Typography variant="h4" fontWeight={700}>
          {getGreeting()}, {user?.name || 'User'}! 👋
        </Typography>
        <Typography variant="body1" sx={{ opacity: 0.9, mt: 1 }}>
          Here's what's happening at {currentSchool?.name || 'your school'} today.
        </Typography>
      </Box>
      
      {action && (
        <Box sx={{ position: 'relative', zIndex: 1 }}>
          {action}
        </Box>
      )}
      
      {/* Decorative Background Elements */}
      <Box
        sx={{
          position: 'absolute',
          top: -100,
          right: -50,
          width: 300,
          height: 300,
          borderRadius: '50%',
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          zIndex: 0,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: -50,
          right: 150,
          width: 150,
          height: 150,
          borderRadius: '50%',
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          zIndex: 0,
        }}
      />
    </Box>
  );
}
